exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#canvas{display:none}li{display:inline;padding:5px}", ""]);

// exports
